var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SideFilter,{ref:"transpSideFilter",staticClass:"mt-0",attrs:{"filter-list":_setup.filtersTransp},on:{"input":_setup.updateFilter,"inputWeek":_setup.updateWeekFilter,"inputYear":_setup.updateYearFilter,"clear":_setup.resetFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }